export const languages = [
  "English",
  "हिंदी",
  "ಕನ್ನಡ",
  "മലയാളം",
  "বাংলা",
  "मराठी",
  "தமிழ்",
  "తెలుగు",
];

export const languageDataset = [
  // English
  {
    topBanner:
      "https://res.cloudinary.com/swiggy/image/upload/v1620200305/DeSo/de-app/covid-microsite/English/english1.png",
    keySteps1:
      "https://res.cloudinary.com/swiggy/image/upload/v1620200305/DeSo/de-app/covid-microsite/English/Group_3832.png",
    callDoc:
      "https://res.cloudinary.com/swiggy/image/upload/v1620200305/DeSo/de-app/covid-microsite/English/english3.png",
    keySteps2:
      "https://res.cloudinary.com/swiggy/image/upload/v1620200305/DeSo/de-app/covid-microsite/English/english4.png",
    callNow:
      "https://res.cloudinary.com/swiggy/image/upload/v1620200305/DeSo/de-app/covid-microsite/English/english5.png",
  },
  // Hindi
  {
    topBanner:
      "https://res.cloudinary.com/swiggy/image/upload/v1620200607/DeSo/de-app/covid-microsite/hindi/final/1.png",
    keySteps1:
      "https://res.cloudinary.com/swiggy/image/upload/v1620200606/DeSo/de-app/covid-microsite/hindi/final/2.png",
    callDoc:
      "https://res.cloudinary.com/swiggy/image/upload/v1620200607/DeSo/de-app/covid-microsite/hindi/final/3.png",
    keySteps2:
      "https://res.cloudinary.com/swiggy/image/upload/v1620200607/DeSo/de-app/covid-microsite/hindi/final/4.png",
    callNow:
      "https://res.cloudinary.com/swiggy/image/upload/v1620200608/DeSo/de-app/covid-microsite/hindi/final/5.png",
  },
  // Kannada
  {
    topBanner:
      "https://res.cloudinary.com/swiggy/image/upload/v1620200960/DeSo/de-app/covid-microsite/Kannada/final/kannada1.png",
    keySteps1:
      "https://res.cloudinary.com/swiggy/image/upload/v1620200960/DeSo/de-app/covid-microsite/Kannada/final/kannada2.png",
    callDoc:
      "https://res.cloudinary.com/swiggy/image/upload/v1620200960/DeSo/de-app/covid-microsite/Kannada/final/kannada3.png",
    keySteps2:
      "https://res.cloudinary.com/swiggy/image/upload/v1620200960/DeSo/de-app/covid-microsite/Kannada/final/kannada4.png",
    callNow:
      "https://res.cloudinary.com/swiggy/image/upload/v1620200959/DeSo/de-app/covid-microsite/Kannada/final/kannada5.png",
  },
  // Malayalam
  {
    topBanner:
      "https://res.cloudinary.com/swiggy/image/upload/v1620201118/DeSo/de-app/covid-microsite/Malayalam/final/1.png",
    keySteps1:
      "https://res.cloudinary.com/swiggy/image/upload/v1620201119/DeSo/de-app/covid-microsite/Malayalam/final/2.png",
    callDoc:
      "https://res.cloudinary.com/swiggy/image/upload/v1620201115/DeSo/de-app/covid-microsite/Malayalam/final/3.png",
    keySteps2:
      "https://res.cloudinary.com/swiggy/image/upload/v1620201120/DeSo/de-app/covid-microsite/Malayalam/final/4.png",
    callNow:
      "https://res.cloudinary.com/swiggy/image/upload/v1620201116/DeSo/de-app/covid-microsite/Malayalam/final/5.png",
  },
  // Bengali
  {
    topBanner:
      "https://res.cloudinary.com/swiggy/image/upload/v1620201338/DeSo/de-app/covid-microsite/Bengali/final/Bengali1.png",
    keySteps1:
      "https://res.cloudinary.com/swiggy/image/upload/v1620201337/DeSo/de-app/covid-microsite/Bengali/final/Bengali2.png",
    callDoc:
      "https://res.cloudinary.com/swiggy/image/upload/v1620201336/DeSo/de-app/covid-microsite/Bengali/final/Bengali3.png",
    keySteps2:
      "https://res.cloudinary.com/swiggy/image/upload/v1620201338/DeSo/de-app/covid-microsite/Bengali/final/Bengali4.png",
    callNow:
      "https://res.cloudinary.com/swiggy/image/upload/v1620201337/DeSo/de-app/covid-microsite/Bengali/final/Bengali5.png",
  },
  // Marathi
  {
    topBanner:
      "https://res.cloudinary.com/swiggy/image/upload/v1620201481/DeSo/de-app/covid-microsite/Marathi/final/Marathi_1.png",
    keySteps1:
      "https://res.cloudinary.com/swiggy/image/upload/v1620201480/DeSo/de-app/covid-microsite/Marathi/final/Marathi2.png",
    callDoc:
      "https://res.cloudinary.com/swiggy/image/upload/v1620201478/DeSo/de-app/covid-microsite/Marathi/final/Marathi_3.png",
    keySteps2:
      "https://res.cloudinary.com/swiggy/image/upload/v1620201479/DeSo/de-app/covid-microsite/Marathi/final/Marathi_4.png",
    callNow:
      "https://res.cloudinary.com/swiggy/image/upload/v1620201478/DeSo/de-app/covid-microsite/Marathi/final/Marathi_5.png",
  },
  // Tamil
  {
    topBanner:
      "https://res.cloudinary.com/swiggy/image/upload/v1620201922/DeSo/de-app/covid-microsite/Tamil/final/1.png",
    keySteps1:
      "https://res.cloudinary.com/swiggy/image/upload/v1620201922/DeSo/de-app/covid-microsite/Tamil/final/2.png",
    callDoc:
      "https://res.cloudinary.com/swiggy/image/upload/v1620201918/DeSo/de-app/covid-microsite/Tamil/final/3.png",
    keySteps2:
      "https://res.cloudinary.com/swiggy/image/upload/v1620201921/DeSo/de-app/covid-microsite/Tamil/final/4.png",
    callNow:
      "https://res.cloudinary.com/swiggy/image/upload/v1620201921/DeSo/de-app/covid-microsite/Tamil/final/5.png",
  },
  // Telugu
  {
    topBanner:
      "https://res.cloudinary.com/swiggy/image/upload/v1620202000/DeSo/de-app/covid-microsite/Telugu/final/1.png",
    keySteps1:
      "https://res.cloudinary.com/swiggy/image/upload/v1620201999/DeSo/de-app/covid-microsite/Telugu/final/2.png",
    callDoc:
      "https://res.cloudinary.com/swiggy/image/upload/v1620201996/DeSo/de-app/covid-microsite/Telugu/final/3.png",
    keySteps2:
      "https://res.cloudinary.com/swiggy/image/upload/v1620202004/DeSo/de-app/covid-microsite/Telugu/final/4.png",
    callNow:
      "https://res.cloudinary.com/swiggy/image/upload/v1620202001/DeSo/de-app/covid-microsite/Telugu/final/5.png",
  },
];
